import React from 'react'
import { API_ENDPOINT_USER_TX, API_VIEW_GRID, SORT_ORDER_ASC, SORT_ORDER_DESC } from '../config'
import { TX_GRID_SORT_ORDER_DESC } from '../actions/tx_grid_sort'
import { buildUrl } from './helpers'

export const getSortIcon = (sortOrder, sortField, field) => {
  let icon = null
  if (sortField && sortField === field) {
    switch (sortOrder) {
      case SORT_ORDER_DESC:
        icon = <i className='fa fa-sort-amount-desc' />
        break
      default:
        icon = <i className='fa fa-sort-amount-asc' />
        break
    }
    if (icon) {
      icon = <div style={{ float: 'right' }}>{icon}</div>
    }
  }
  return icon
}

export const getSortDirection = (sortOrder, sortField, field) => {
  let sortDirection = SORT_ORDER_ASC
  if (sortField && sortField === field) {
    switch (sortOrder) {
      case SORT_ORDER_DESC:
        sortDirection = null
        break
      default:
        sortDirection = SORT_ORDER_DESC
    }
  }
  return sortDirection
}

export const buildUserTxDataUrl = (
  page = 1,
  state = null,
  search = null,
  sortBy = null,
  order = null,
  clientId = null,
  country = null,
  pageSize = 20,
  createdOn
) => {
  let queryParams = { page, view: API_VIEW_GRID }
  if (pageSize) {
    queryParams = { ...queryParams, ...{ page_size: pageSize } }
  }
  if (state) {
    queryParams = { ...queryParams, ...{ states: state } }
  }
  if (search) {
    const { searchTerm, searchParameter } = search
    queryParams = { ...queryParams, ...{ [searchParameter]: searchTerm } }
  }
  if (clientId) {
    queryParams = { ...queryParams, ...{ client_id: clientId } }
  }
  if (country) {
    queryParams = { ...queryParams, ...{ transaction_identity__country_code: country } }
  }

  if (createdOn) {
    queryParams = { ...queryParams, ...{ created_on: createdOn } }
  }

  if (sortBy) {
    if (order === TX_GRID_SORT_ORDER_DESC) {
      sortBy = `-${sortBy}`
    }
    queryParams = { ...queryParams, ...{ ordering: sortBy } }
  }
  return buildUrl(`${API_ENDPOINT_USER_TX}/`, { ...queryParams })
}

export const buildUserTxDataUrlDetails = (
  page = null,
  state = null,
  search = null,
  sortBy = null,
  order = null,
  country = null,
  index,
  createdOn,
  pageSize
) => {
  const realPage = page || 1
  let queryParams = {
    page: (realPage - 1) * pageSize + parseInt(index, 10) + 1,
    page_size: 1,
    view: API_VIEW_GRID,
  }

  if (state) {
    queryParams = { ...queryParams, ...{ states: state } }
  }
  if (search) {
    queryParams = { ...queryParams, ...{ search } }
  }
  if (country) {
    queryParams = { ...queryParams, ...{ transaction_identity__country_code: country } }
  }
  if (createdOn) {
    queryParams = { ...queryParams, ...{ created_on: createdOn } }
  }

  if (sortBy) {
    if (order === TX_GRID_SORT_ORDER_DESC) {
      sortBy = `-${sortBy}`
    }
    queryParams = { ...queryParams, ...{ ordering: sortBy } }
  }
  return buildUrl(`${API_ENDPOINT_USER_TX}/`, { ...queryParams })
}

export const buildUserTxDataUrlInsights = (
  page = null,
  state = null,
  search = null,
  sortBy = null,
  order = null,
  clientId = null,
  transactionIdentityCountryCode = null,
  transactionIdentity = null,
  pageSize = null,
  createdBy = null,
  error = null,
  faceMatchMin = null,
  faceMatchMax = null,
  image = null,
  fast = false
) => {
  let queryParams = { page: page || 1 }

  if (state) {
    queryParams = { ...queryParams, ...{ state } }
  }
  if (search) {
    queryParams = { ...queryParams, ...{ search } }
  }
  if (clientId) {
    queryParams = { ...queryParams, ...{ client_id: clientId } }
  }
  if (transactionIdentity) {
    queryParams = { ...queryParams, ...{ transaction_identity: transactionIdentity } }
  }
  if (transactionIdentityCountryCode) {
    queryParams = {
      ...queryParams,
      ...{ transaction_identity__country_code: transactionIdentityCountryCode },
    }
  }
  if (pageSize) {
    queryParams = { ...queryParams, ...{ page_size: pageSize } }
  }
  if (createdBy) {
    queryParams = { ...queryParams, ...{ created_by: createdBy } }
  }
  if (error) {
    queryParams = { ...queryParams, ...{ error } }
  }
  if (faceMatchMin) {
    queryParams = { ...queryParams, ...{ face_match_min: faceMatchMin } }
  }
  if (faceMatchMax) {
    queryParams = { ...queryParams, ...{ face_match_max: faceMatchMax } }
  }
  if (image) {
    queryParams = { ...queryParams, ...{ transaction_id: image } }
  }

  if (sortBy) {
    if (order === TX_GRID_SORT_ORDER_DESC) {
      sortBy = `-${sortBy}`
    }
    queryParams = { ...queryParams, ...{ ordering: sortBy } }
  }

  return buildUrl(
    '/api/transactions',
    // path: fast ? API_ENDPOINT_USER_TX_INSIGHTS_FAST : `${API_ENDPOINT_USER_TX_INSIGHTS}`,
    // path: ,
    { ...queryParams }
  )
}
